import { Spy } from '@naker/design/Services/spy';
import { Api } from '@naker/design/Services/api';
import { Session } from '@naker/design/services/session';
import { BackUndo } from './undo';
import { BackEngine } from '../../viewer/back';
import { editorSystem } from './systemEditor';
import { NakerViewer } from '@naker/services/Viewer/viewer';

let container = document.getElementById("container");
let viewer = new NakerViewer({ container: container, waterMark: false });
let system = new editorSystem(viewer.canvas);

export let backEngine = new BackEngine({ particle: {}, environment: {} }, system);

export let undo = new BackUndo(backEngine.environment, backEngine.particle);

export let spy = new Spy();
export let api = new Api();
export let session = new Session('back', api, spy, undo);

session.setThumbnailFunction((callback) => {
    system.takeScreenshot({ height: 200, width: 300 }, callback);
});

undo.on('change', (change) => {
    if (change.particle) backEngine.particle.setOptions(change.particle);
    if (change.environment) backEngine.environment.setOptions(change.environment);
});

// TO test screenshot function
// setTimeout(() => {
//     system.takeScreenshot({ height: 200, width: 300 }, () => {});
// }, 3000);